export default __webpack_public_path__ + "static/media/molecular-biology-benchtop-solution.7f2ed367.png";